import Composicao from "./composicao";
import Configuracao from "./configuarcao";
import Dashboard from "./dashboard";
import Etapa from "./etapa";
import Grupo from "./grupo";
import Insumo from "./insumo";
import Login from "./login";
import Orcamento from "./orcamento";
import Servico from "./servico";
import Usuario from "./usuario";

export { Composicao, Configuracao, Dashboard, Etapa, Grupo, Insumo, Login, Orcamento, Servico, Usuario };



// WEBPACK FOOTER //
// ./src/services/index.js